/* eslint-disable */
import React, { useContext, useState, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'

import CheckIcon from 'assets/icons/check-icon'
import Button from 'components/Button'
import Container from 'components/Container'
import Row from 'components/Row'
import Col from 'components/Col'
import Select from 'components/Select'
import { congregationOptions } from 'constants/congregationOptions'
import Input from 'components/Input'
import Textarea from 'components/Textarea'
import { defaultSiteProposalValidationResults } from 'constants/defaultSiteProposalValidationResults'
import { minBestMaxValidation, minMaxValidation } from 'utils/minBestMaxValidation'
import { updateSpeciesCongregation, getSeasonalDistributions } from 'api/congregations'
import { delay } from 'utils/delay'
import formatNum2Dp from 'utils/formatNum2DP'
import { SITE_STATUS_DRAFT_ID } from 'constants/siteStatuses'
import { SiteContext } from 'providers/site'
import { reasonDefaultOptions, reasonOptionsIrreversibleSelected, reasonOptionsReversibleSelected, IrreversibleIndex, ReversibleIndex } from 'constants/rejectTriggerReason'

// Create congregation-specific options for mutual exclusivity
const reasonQualifyOptions = [
  { label: 'Qualifies', value: 1, disabled: false },
  { label: 'Improved site information', value: 2, disabled: true },
  { label: 'KBA criteria revision', value: 3, disabled: true },
  { label: 'Revision to Red List status', value: 4, disabled: true },
  { label: 'Revision of global threshold', value: 5, disabled: true },
  { label: 'No longer geographically restricted', value: 6, disabled: true },
  { label: 'Genuine decline, irreversible', value: 7, disabled: true },
  { label: 'Genuine decline, reversible', value: 8, disabled: true },
  { label: 'Genuine decline, other factors', value: 9, disabled: true }
]

const reasonNonQualifyOptions = [
  { label: 'Qualifies', value: 1, disabled: true },
  { label: 'Improved site information', value: 2, disabled: false },
  { label: 'KBA criteria revision', value: 3, disabled: false },
  { label: 'Revision to Red List status', value: 4, disabled: false },
  { label: 'Revision of global threshold', value: 5, disabled: false },
  { label: 'No longer geographically restricted', value: 6, disabled: false },
  { label: 'Genuine decline, irreversible', value: 7, disabled: false },
  { label: 'Genuine decline, reversible', value: 8, disabled: false },
  { label: 'Genuine decline, other factors', value: 9, disabled: false }
]
import MultiSelectionDropdown from 'components/MultiSelectDropdown'

import { CongregationContentFinishEditingWrapper } from './style'


const fields = {
  min: 'minCongregationEstimate',
  best: 'bestCongregationEstimate',
  max: 'maxCongregationEstimate',
  year_min: 'yearMin',
  year_max: 'yearMax'
}

const inputSaveDelayTime = 300
const updateCongregationDetails = delay(inputSaveDelayTime)

const findCongregationsError = (id, fieldValidation, defaultValidation) => {
  if (id === 'defaultTestId' || !fieldValidation?.updated || !fieldValidation?.congregations) {
    return defaultValidation.congregations
  }
  return fieldValidation.congregations[id] || defaultValidation.congregations
}

const CongregationContent = ({
  item,
  toggleAccordion,
  updateCongregationList,
  createCongregations,
  options,
  site,
  defaultItem,
  params,
  getSpeciesCongregationList
}) => {
  const { siteProposalFieldValidation } = useContext(SiteContext)

  const [speciesGroup, setSpeciesGroup] = useState(congregationOptions.find((element) => {
    return element.value === item.CongregationGroupId
  }) || null)
  const [minEstimate, setMinEstimate] = useState(item.min ? formatNum2Dp(item.min) : '')
  const [bestEstimate, setBestEstimate] = useState(item.best ? formatNum2Dp(item.best) : '')
  const [maxEstimate, setMaxEstimate] = useState(item.max ? formatNum2Dp(item.max) : '')
  const [yearMin, setYearMin] = useState(item.year_min ? item.year_min.toString() : '')
  const [yearMax, setYearMax] = useState(item.year_max ? item.year_max.toString() : '')
  const [season, setSeason] = useState(() => {
    if (item.season_id) {
      // Check if we have the seasonal distribution data included from backend
      if (item.SeasonalDistribution) {
        return { value: item.season_id, label: item.SeasonalDistribution.name }
      }
      // Fallback to season_name if available
      return { value: item.season_id, label: item.season_name || `Season ${item.season_id}` }
    }
    return null
  })
  const [seasonalDistributions, setSeasonalDistributions] = useState([])
  const [details, setDetails] = useState(item.description)
  const [error, setError] = useState({ field: '', error: '' })
  const [qualificationReason, setQualificationReason] = useState(item.trigger_reason_id?.map((item) => {
    if (Number(item) > 3) {
      return Number(item) - 1
    }
    return Number(item)
  }))
  const [reassessmentRational, setReassessmentRational] = useState(item.trigger_reason_text ? item.trigger_reason_text : '')
  const [checkedOptions, setCheckedOptions] = useState(reasonDefaultOptions)

  const qualified = item.reassessmentFlag ? item.trigger_reason_id?.some((element) => {
    return element === 1
  }) : true

  const disabled = speciesGroup === null || site.SiteStatusId !== SITE_STATUS_DRAFT_ID

  const validationCongregation = findCongregationsError(item.id, siteProposalFieldValidation, defaultSiteProposalValidationResults)

  const handleChangeSpeciesGroup = (e) => {
    setSpeciesGroup(e)
    createCongregations(e.value)
  }
  const handleChangeMinEstimate = (e) => {
    if ((e.target.value !== '' && !Number.isInteger(Number(e.target.value))) || !Number.isInteger(Number(e.target.value))) {
      return setMinEstimate((s) => {
        return s === null ? '' : s
      })
    }

    const errorMessage = minBestMaxValidation(e.target.value, bestEstimate, maxEstimate, fields, 'min')

    if (errorMessage.field !== '') {
      setMinEstimate(e.target.value)
      setError(errorMessage)
      return updateCongregationList({ ...item, min: e.target.value })
    }

    setMinEstimate(e.target.value)
    setError(errorMessage)
    updateSpeciesCongregation(site.id, item.id, params.siteHistoryId, item.historyId, {
      max: maxEstimate === '' || maxEstimate === null ? null : Number(maxEstimate),
      best: bestEstimate === '' || bestEstimate === null ? null : Number(bestEstimate),
      min: e.target.value === '' ? null : Number(e.target.value),
      year_min: yearMin === '' ? null : Number(yearMin),
      year_max: yearMax === '' ? null : Number(yearMax),
      season_id: season ? season.value : null
    }).then((data) => {
      updateCongregationList(data)
      if (getSpeciesCongregationList) {
        getSpeciesCongregationList()
      }
    })
  }

  const handleChangeBestEstimate = (e) => {
    if ((e.target.value !== '' && !Number.isInteger(Number(e.target.value))) || !Number.isInteger(Number(e.target.value))) {
      return setBestEstimate((s) => {
        return s === null ? '' : s
      })
    }

    const errorMessage = minBestMaxValidation(minEstimate, e.target.value, maxEstimate, fields, 'best')

    if (errorMessage.field !== '') {
      setBestEstimate(e.target.value)
      setError(errorMessage)
      return updateCongregationList({ ...item, best: e.target.value })
    }
    setBestEstimate(e.target.value)
    setError(errorMessage)
    updateSpeciesCongregation(site.id, item.id, params.siteHistoryId, item.historyId, {
      max: maxEstimate === '' || maxEstimate === null ? null : Number(maxEstimate),
      best: e.target.value === '' ? null : Number(e.target.value),
      min: minEstimate === '' || minEstimate === null ? null : Number(minEstimate),
      year_min: yearMin === '' ? null : Number(yearMin),
      year_max: yearMax === '' ? null : Number(yearMax),
      season_id: season ? season.value : null
    }).then((data) => {
      updateCongregationList(data)
      if (getSpeciesCongregationList) {
        getSpeciesCongregationList()
      }
    })
  }

  const handleChangeMaxEstimate = (e) => {
    if ((e.target.value !== '' && !Number.isInteger(Number(e.target.value))) || !Number.isInteger(Number(e.target.value))) {
      return setMaxEstimate((s) => {
        return s === null ? '' : s
      })
    }

    const errorMessage = minBestMaxValidation(minEstimate, bestEstimate, e.target.value, fields, 'max')

    if (errorMessage.field !== '') {
      setError(errorMessage)
      setMaxEstimate(e.target.value)
      return updateCongregationList({ ...item, max: e.target.value })
    }

    setError(errorMessage)
    setMaxEstimate(e.target.value)
    updateSpeciesCongregation(site.id, item.id, params.siteHistoryId, item.historyId, {
      max: e.target.value === '' ? null : Number(e.target.value),
      best: bestEstimate === '' || bestEstimate === null ? null : Number(bestEstimate),
      min: minEstimate === '' || minEstimate === null ? null : Number(minEstimate),
      year_min: yearMin === '' ? null : Number(yearMin),
      year_max: yearMax === '' ? null : Number(yearMax),
      season_id: season ? season.value : null
    }).then((data) => {
      updateCongregationList(data)
      if (getSpeciesCongregationList) {
        getSpeciesCongregationList()
      }
    })
  }

  const handleChangeDetails = (e) => {
    setDetails(e.target.value)
    updateCongregationDetails(() => {
      updateSpeciesCongregation(site.id, item.id, params.siteHistoryId, item.historyId, {
        description: e.target.value,
        year_min: yearMin === '' ? null : Number(yearMin),
        year_max: yearMax === '' ? null : Number(yearMax),
        season_id: season ? season.value : null
      }).then((data) => {
        updateCongregationList(data)
      })
    })
  }

  const handleChangeYearMin = (e) => {
    const value = e.target.value
    if (value !== '' && !Number.isInteger(Number(value))) {
      return
    }
    const errorMessage = minMaxValidation(value, yearMax, fields, 'year_min')

    if (errorMessage.field !== '') {
      setYearMin(value)
      setError(errorMessage)
      return updateCongregationList({ ...item, year_min: value })
    }
    setYearMin(value)
    setError(errorMessage)
    updateSpeciesCongregation(site.id, item.id, params.siteHistoryId, item.historyId, {
      year_min: value === '' ? null : Number(value),
      year_max: yearMax === '' ? null : Number(yearMax),
      season_id: season ? season.value : null
    }).then((data) => {
      updateCongregationList(data)
      if (getSpeciesCongregationList) {
        getSpeciesCongregationList()
      }
      if (getSpeciesCongregationList) {
        getSpeciesCongregationList()
      }
    })
  }

  const handleChangeYearMax = (e) => {
    const value = e.target.value
    if (value !== '' && !Number.isInteger(Number(value))) {
      return
    }

    const errorMessage = minMaxValidation(yearMin, value, fields, 'year_max')

    if (errorMessage.field !== '') {
      setYearMax(value)
      setError(errorMessage)
      return updateCongregationList({ ...item, year_max: value })
    }

    setYearMax(value)
    setError(errorMessage)
    updateSpeciesCongregation(site.id, item.id, params.siteHistoryId, item.historyId, {
      year_min: yearMin === '' ? null : Number(yearMin),
      year_max: value === '' ? null : Number(value),
      season_id: season ? season.value : null
    }).then((data) => {
      updateCongregationList(data)
      if (getSpeciesCongregationList) {
        getSpeciesCongregationList()
      }
    })
  }

  const handleChangeSeason = (selectedSeason) => {
    setSeason(selectedSeason)
    updateSpeciesCongregation(site.id, item.id, params.siteHistoryId, item.historyId, {
      year_min: yearMin === '' ? null : Number(yearMin),
      year_max: yearMax === '' ? null : Number(yearMax),
      season_id: selectedSeason ? selectedSeason.value : null
    }).then((data) => {
      updateCongregationList(data)
      if (getSpeciesCongregationList) {
        getSpeciesCongregationList()
      }
    })
  }

  function handleChangeValueChecked(Ids) {
    const qualifyIndex = 0 // "Qualifies" is at index 0
    const isAnyNonQualifyOptionsSelected = Ids.some((item) => {
      return item.checked && item.value !== 1
    })

    if (Ids[IrreversibleIndex].checked) {
      setCheckedOptions(reasonOptionsIrreversibleSelected)
    } else if (Ids[ReversibleIndex].checked) {
      setCheckedOptions(reasonOptionsReversibleSelected)
    } else if (Ids[qualifyIndex].checked) {
      setCheckedOptions(reasonQualifyOptions)
    } else if (isAnyNonQualifyOptionsSelected) {
      setCheckedOptions(reasonNonQualifyOptions)
    } else {
      setCheckedOptions(reasonDefaultOptions)
    }
  }

  function handleChangeQualificationReason(e) {
    setQualificationReason(e)

    const formattedReasons = e.map((item) => {
      if (item > 3) {
        return item + 1
      }
      return item
    })

    // Handle delisting logic - clear estimates when non-qualifying reasons are selected
    const isDelisting = formattedReasons.some(id => id > 1)
    const updateData = {
      trigger_reason_id: formattedReasons,
      year_min: yearMin === '' ? null : Number(yearMin),
      year_max: yearMax === '' ? null : Number(yearMax),
      season_id: season ? season.value : null
    }

    // Clear estimates if delisting
    if (isDelisting) {
      updateData.min = null
      updateData.best = null
      updateData.max = null
      setMinEstimate('')
      setBestEstimate('')
      setMaxEstimate('')
    }

    updateSpeciesCongregation(site.id, item.id, params.siteHistoryId, item.historyId, updateData).then((data) => {
      updateCongregationList(data)
      if (getSpeciesCongregationList) {
        getSpeciesCongregationList()
      }
    })
  }

  function handleChangeReassessmentRational(e) {
    setReassessmentRational(e.target.value)

    updateCongregationDetails(() => {
      updateSpeciesCongregation(site.id, item.id, params.siteHistoryId, item.historyId, {
        trigger_reason_text: e.target.value,
        year_min: yearMin === '' ? null : Number(yearMin),
        year_max: yearMax === '' ? null : Number(yearMax),
        season_id: season ? season.value : null
      }).then((data) => {
        updateCongregationList(data)
      })
    })
  }

  useEffect(() => {
    getSeasonalDistributions().then((data) => {
      const options = data.map(dist => ({
        value: dist.id,
        label: dist.name
      }))
      setSeasonalDistributions(options)
      const selectedSeason = options.find(opt => opt.value === season.value) || null;
      setSeason(selectedSeason)
    }).catch((err) => {
      console.error('Error fetching seasonal distributions:', err)
    })
  }, [])

  return (
    <Container width='100%' padding='0px' data-test='congregations-form'>
      <Row>
        <Col md={6} data-testId='congregation-group-select'>
          <Select
            label='congregationSpeciesGroup'
            value={speciesGroup}
            placeholder='congregationSpeciesGroupPlaceholder'
            options={options}
            onChange={handleChangeSpeciesGroup}
            disabled={speciesGroup !== null}
          />
        </Col>
        <Col md={6} data-testId='year-min-input'>
          <Input
            value={yearMin}
            onChange={handleChangeYearMin}
            field='yearMin'
            label='yearMin'
            infoTooltip='yearMinToolTip'
            placeholder='yearMinPlaceholder'
            isOptional={true}
            disabled={disabled}
            error={error.field === 'yearMin' ? error : { field: '', error: '' }}
            title='Enter earliest year of the data'
          />
        </Col>
      </Row>
      <Row>
        <Col md={6} data-testId='year-max-input'>
          <Input
            value={yearMax}
            onChange={handleChangeYearMax}
            field='yearMax'
            label='yearMax'
            infoTooltip='yearMaxToolTip'
            placeholder='yearMaxPlaceholder'
            isOptional={true}
            disabled={disabled}
            error={error.field === 'yearMax' ? error : { field: '', error: '' }}
            title='Enter latest year of the data'
          />
        </Col>
        <Col md={6} data-testId='season-select'>
          <Select
            label='season'
            field="season"
            infoTooltip="seasonToolTip"
            value={season}
            isOptional={true}
            placeholder='seasonPlaceholder'
            options={seasonalDistributions}
            onChange={handleChangeSeason}
            disabled={disabled}
            title='Select season'
          />
        </Col>
      </Row>
      <Row>
        <Col md={6} data-testId='minCongregationEstimate-input'>
          <Input
            value={minEstimate}
            onChange={handleChangeMinEstimate}
            field='minCongregationEstimate'
            label='minCongregationEstimate'
            placeholder='minCongregationPlaceholder'
            isOptional={true}
            disabled={disabled}
            error={error}
          />
        </Col>
        <Col md={6} data-testId='bestCongregationEstimate-input'>
          <Input
            value={bestEstimate}
            onChange={handleChangeBestEstimate}
            field='bestCongregationEstimate'
            label='bestCongregationEstimate'
            isOptional={true}
            placeholder='bestCongregationPlaceholder'
            disabled={disabled}
          />
        </Col>
      </Row>
      <Row>
        <Col md={6} data-testId='maxCongregationEstimate-input'>
          <Input
            value={maxEstimate}
            onChange={handleChangeMaxEstimate}
            field='maxCongregationEstimate'
            label='maxCongregationEstimate'
            placeholder='maxCongregationPlaceholder'
            isOptional={true}
            disabled={disabled}
            error={error}
          />
        </Col>
        {(item.lastReassessmentDate !== null && site.reassessmentFlag && !defaultItem) && (
          <Col md={6}>
            <MultiSelectionDropdown
              value={qualificationReason}
              saveChanges={handleChangeQualificationReason}
              valueChecked={handleChangeValueChecked}
              label='triggerCongregationLabel'
              infoTooltip='triggerLabelHint'
              field='qualificationReason'
              error={qualificationReason?.length === 0 ? {
                field: 'qualificationReason',
                error: 'pleaseCompleteThisField'
              } : { field: '', error: '' }}
              secondStepOptions={checkedOptions}
              placeholder='congregationTriggerPlaceholder'
            />
          </Col>
        )}
      </Row>
        {(item.lastReassessmentDate !== null && site.reassessmentFlag && !defaultItem) && (
        <Row>
          <Col md={12} data-testId='reassessmentRational-textarea'>
            <Textarea
              value={reassessmentRational}
              onChange={handleChangeReassessmentRational}
              placeholder='justificationNoChangeCongregationPlaceholder'
              label='justificationNoChange'
              infoTooltip='qualificationReasonHint'
              field='rationalForReassessment'
              height='128px'
              disabled={disabled}
            />
          </Col>
        </Row>
      )}
      <Row>
        <Col md={12} data-testId='detailsCongregationLabel-textarea' style={{ marginTop: "5px" }}>
          <Textarea
            value={details}
            onChange={handleChangeDetails}
            placeholder='detailsCongregationPlaceholder'
            label='detailsCongregationLabel'
            height='148px'
            isOptional={true}
            disabled={disabled}
            marginBottom='0'
          />
        </Col>
      </Row>
      {(item.reassessmentFlag && site.SiteStatusId === SITE_STATUS_DRAFT_ID && !defaultItem) && (
        <Row>
          <Col md={12}>
            <CongregationContentFinishEditingWrapper>
              <Button height='40px' isDisabled={!item.trigger_reason_id?.length > 0} onClick={() => {
                toggleAccordion()
              }}
                type={item.trigger_reason_id?.length > 0 ? 'primary' : 'disabledPrimary'}>
                <CheckIcon />
                <FormattedMessage id='finishEditing' />
              </Button>
            </CongregationContentFinishEditingWrapper>
          </Col>
        </Row>
      )}
      {(!item.reassessmentFlag && site.SiteStatusId === SITE_STATUS_DRAFT_ID && !defaultItem) && (
        <Row>
          <Col md={12}>
            <CongregationContentFinishEditingWrapper>
              <Button height='40px' onClick={toggleAccordion}
                type='primary'>
                <CheckIcon />
                <FormattedMessage id='finishEditing' />
              </Button>
            </CongregationContentFinishEditingWrapper>
          </Col>
        </Row>
      )}
    </Container>
  )
}

export default CongregationContent
